import { EventDetailsTabAssistingAgencyDto } from '@mark43/cad-api';
import { VStack, Text, Box } from '@cad-arc';
import { AssistingAgenciesSectionContent } from '../../event-panel/tabs/event-details/components/sections/assisting-agencies-section-content';
import { SectionTitle } from '../../fr-event-common-components/section-title';

export function FrAssistingAgenciesSection({
    assistingAgencies,
}: {
    assistingAgencies: EventDetailsTabAssistingAgencyDto[];
}) {
    return (
        <VStack alignItems="flex-start" w="100%">
            <SectionTitle title="Assisting Agencies" />
            {assistingAgencies.length > 0 ? (
                <Box w="100%">
                    <AssistingAgenciesSectionContent assistingAgencies={assistingAgencies} />
                </Box>
            ) : (
                <Text fontSize="sm" variant="bodyMd" color="placeholder">
                    None
                </Text>
            )}
        </VStack>
    );
}
